import { defineComponent as _defineComponent } from 'vue'
import { ref, getCurrentInstance } from 'vue'
import { useOnline } from '@vueuse/core'
import { Message } from 'element-ui'
import { uploadImage } from '@/services/image-upload-client'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadPhoto',
  props: {
    label: { default: '写真をアップロードする' },
    icon: { default: 'el-icon-picture' },
    capture: { default: null }
  },
  emits: ["upload-photo-complete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'upload-photo-complete', imageSrc: string): void
}), expose: any, slots: any, attrs: any }) {





// GTM だけはモジュール入口が無いため instance 経由で取る（CLAUDE.md: 依存を増やさない範囲で最小限）
const gtm = (
  getCurrentInstance()?.proxy as unknown as {
    $gtm?: { sendError: (area: string, message: string) => void }
  }
)?.$gtm

const isOnline = useOnline()
const loading = ref(false)
const errorMessage = ref('')
const inputId = `upload-photo-${Math.random().toString(36).substring(2, 11)}`

async function selectedFile(event: Event) {
  event.preventDefault()
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  // 同じファイルを選び直しても change が発火するように値を戻す
  // （File は取得済みなのでここでクリアしてよい）
  input.value = ''
  if (!file) return

  if (!isOnline.value) {
    Message({
      message:
        '現在オフラインです。インターネットにつながってから再度お試しください',
      type: 'warning'
    })
    return
  }

  loading.value = true
  try {
    const imageSrc = await uploadImage(file)
    errorMessage.value = ''
    // 同じ写真を選び直すと応答の data URL が前回と同一になる。値の変化を条件に
    // すると発火しないため、アップロード成功のたびにそのまま emit する
    emit('upload-photo-complete', imageSrc)
  } catch (error) {
    console.error(error)
    gtm?.sendError('upload photo', String(error))
    errorMessage.value = 'アップロードに失敗しました'
  } finally {
    loading.value = false
  }
}

return { __sfc: true,emit, gtm, isOnline, loading, errorMessage, inputId, selectedFile }
}

})